import defaultState, { defaultInfo } from './defaultState'

const unwrapState = state => state.company || defaultState

export const getCompanyInfo = state => unwrapState(state).info || defaultInfo
export const getCompanyLoading = state => unwrapState(state).loading
export const getCompanyLoaded = state => getCompanyInfo(state).id
export const getCompanyError = state => unwrapState(state).error
